import styles from "../components/PageEdit.module.css"
import axios from "axios";

export default function Logout(){

    const API_URL = process.env.NODE_ENV === "development"
        ? "http://localhost:3000/"
        : "https://api.hillerodfrimenighed.dk/";

    async function handleLogout() {
        try {

            await axios.post(`${API_URL}user/logout`, {},
                {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                },
            });

            window.location.href = "/"; 

        } catch (error) {
            console.error("Save error:", error);
        }
    }

    return(
        <button onClick={handleLogout} className={styles.logout}>
            Logout
        </button>
    );
}